var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDefaultUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 3.79297C4.375 5.24022 5.55275 6.41797 7 6.41797C8.44725 6.41797 9.625 5.24022 9.625 3.79297C9.625 2.34572 8.44725 1.16797 7 1.16797C5.55275 1.16797 4.375 2.34572 4.375 3.79297ZM11.6667 12.2513H12.25V11.668C12.25 9.41689 10.4177 7.58464 8.16667 7.58464H5.83333C3.58167 7.58464 1.75 9.41689 1.75 11.668V12.2513H11.6667Z",
    fill: "#A9ADB1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDefaultUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/default-user.14e66dd4.svg";
export { ForwardRef as ReactComponent };